import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class GroupCssClassService extends FormulateCssClassService {
    public process(): void {
        this.addClass([
        ])
    }
}

export default GroupCssClassService
